import React, { useContext, useEffect, useState } from 'react';
import { Form, Input, Button, message, Spin, Select } from 'antd';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { LoginContext } from '../../../../context/loginContext';

const CUsuarioEmpresa = () => {
    const { user } = useContext(LoginContext);
    const [form] = Form.useForm();
    const { id } = useParams();
    const [loading, setLoading] = useState(!!id);
    const [sucursales, setSucursales] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const usuarioDesdeLista = location.state;

    const fetchUsuario = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/usuario/${id}`, {
                headers: { Authorization: `Bearer ${user.token}` }
            });

            if (!res.ok) throw new Error('Error al obtener usuario');

            const data = await res.json();
            form.setFieldsValue(data);
        } catch (err) {
            message.error('Error al cargar el usuario');
        } finally {
            setLoading(false);
        }
    };

    const fetchSucursales = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/sucursal/empresa`, {
                headers: { Authorization: `Bearer ${user.token}` }
            });

            if (!res.ok) throw new Error('Error al obtener sucursales');

            const data = await res.json();
            setSucursales(data);
        } catch (error) {
            console.error(error);
            message.error('Error al cargar sucursales');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSucursales();

        if (id && usuarioDesdeLista) {
            // Ya tenemos los datos del usuario, los usamos directamente
            form.setFieldsValue({
                usuario: usuarioDesdeLista.usu_usuario,
                contrasenia: '', // Dejar vacío o pedir al usuario que la reescriba
                sucursal: usuarioDesdeLista.usu_sucursal,
            });
            setLoading(false);
        } else if (id) {
            // Fallback por si alguien entra directo por URL sin state
            fetchUsuario();
        } else {
            setLoading(false);
        }
    }, [id]);


    const onFinish = async (values) => {
        try {
            const method = id ? 'PUT' : 'POST';
            const endpoint = id
                ? `${process.env.REACT_APP_API_URL}/usuarios/${id}`
                : `${process.env.REACT_APP_API_URL}/usuarios`;

            // Agregar tipoUsuario: 2 a los valores enviados
            const payload = {
                ...values,
                tipoUsuario: 2,
                empresa: user.emp_id
            };

            const res = await fetch(endpoint, {
                method,
                headers: {
                    'Authorization': `Bearer ${user.token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!res.ok) throw new Error('Error al guardar el usuario');

            message.success(id ? 'Usuario actualizado' : 'Usuario creado');
            navigate('/lista-usuarios-empresa');
        } catch (err) {
            message.error('Error al guardar el usuario');
        }
    };


    if (loading) return <Spin style={{ marginTop: '5rem' }} />;

    return (
        <div style={{ maxWidth: 600, margin: '2rem auto' }}>
            <h2 style={{ textAlign: 'center' }}>{id ? 'Editar' : 'Nuevo'} Usuario</h2>
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Form.Item
                    label="Usuario"
                    name="usuario"
                    rules={[{ required: true, message: 'Ingrese una contraseña' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Contraseña"
                    name="contrasenia"
                    rules={
                        !id
                            ? [{ required: true, message: 'Ingrese una contraseña' }]
                            : []
                    }
                >
                    <Input.Password />
                </Form.Item>


                <Form.Item
                    label="Sucursal"
                    name="sucursal"
                    rules={[{ required: true, message: 'Seleccione una sucursal' }]}
                >
                    <Select placeholder="Seleccione una sucursal">
                        {sucursales.map((sucursal) => (
                            <Select.Option key={sucursal.suc_id} value={sucursal.suc_id}>
                                {sucursal.suc_nombre}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item style={{ textAlign: 'center' }}>
                    <Button type="primary" htmlType="submit">
                        Guardar
                    </Button>
                    <Button style={{ marginLeft: 8 }} onClick={() => navigate('/lista-usuarios-empresa')}>
                        Cancelar
                    </Button>
                </Form.Item>
            </Form>

        </div>
    );
};

export default CUsuarioEmpresa;
